import { render, staticRenderFns } from "./FormFotoProducto.vue?vue&type=template&id=328c8ccc&"
import script from "./FormFotoProducto.vue?vue&type=script&lang=js&"
export * from "./FormFotoProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports